import { SET_FEATURED_ITEMS } from "./actions"

const INITIAL_STATE = {
  items: [],
}

export default function featuredItemsReducer(
  state = INITIAL_STATE,
  action: any
) {
  switch (action.type) {
    case SET_FEATURED_ITEMS:
      return { ...state, items: action.items }
    default:
      return state
  }
}
